export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function getDeviceInfo() {
	if (typeof navigator === 'undefined') {
		return { device: null, browser: null, os: null };
	}

	const ua = navigator.userAgent;

	let device = 'desktop';
	if (/Mobi|Android/i.test(ua)) {
		device = /Tablet|iPad/i.test(ua) ? 'tablet' : 'mobile';
	}

	let browser = 'unknown';
	if (ua.includes('Firefox')) browser = 'firefox';
	else if (ua.includes('Edg')) browser = 'edge';
	else if (ua.includes('Chrome')) browser = 'chrome';
	else if (ua.includes('Safari')) browser = 'safari';
	else if (ua.includes('Opera') || ua.includes('OPR')) browser = 'opera';

	let os = 'unknown';
	if (ua.includes('Windows')) os = 'windows';
	else if (ua.includes('Mac')) os = 'macos';
	else if (ua.includes('Linux')) os = 'linux';
	else if (ua.includes('Android')) os = 'android';
	else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'ios';

	return { device, browser, os };
}
